const TokenKey = process.env.VUE_APP_AUTH_KEY
const regionKey = 'admin.region'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
